import React, { useState } from 'react'
import styles from './styles.module.scss'
import parentStyles from '../../../styles.module.scss'
import CardTitle from '../../common/CardTitle'
import EmptyCard from '../../common/EmptyCard'
import { useTranslation } from 'react-i18next'
import CardSubTitle from '../../common/CardSubTitle'
import ActivityBoxInterests from '../../common/ActivityBoxInterests'
import Button from 'srcReact/components/common2/Button'
import { useDispatch, useSelector } from 'react-redux'
import Modal from 'srcReact/components/common2/Modal'
import FinalizeInvitationsModal from 'srcReact/components/popinsContent/FinalizeInvitationsModal'
import InviteMembersSuccessModal from 'srcReact/components/popinsContent/InviteMembersSuccessModal'
import { groupActions } from 'srcReact/GroupPage'
import AddGroupInterests from 'srcReact/components/common2/AddGroupInterests'
import UserList from '../../common/UserList'

function Interests({}) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  // const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false)
  const [userToRemove, setUserToRemove] = useState(null)
  // const [errorMessage, setErrorMessage] = useState('')
  const [showSuccessModal, setShowSuccessModal] = useState(false)
  const [showFinalizeModal, setShowFinalizeModal] = useState(false)
  const [selectedMembers, setSelectedMembers] = useState([])
  const [isInterestModalOpen, setIsInterestModalOpen] = useState(false)

  const {
    login: { user: loggedInUser },
    dashboardDetail: { data }
  } = useSelector((state) => state)

  const handleKeyPressed = (e) => {
    if (e.key === 'Escape') {
      e.stopPropagation()
    }
  }
  const handleSendInvites = (id, membersId, message, callback) => {
    dispatch(groupActions.sendInvites(id, membersId, message, callback))
  }
  const openInterestModal = () => {
    setIsInterestModalOpen(true)
  }
  const closeInterestModal = () => {
    setIsInterestModalOpen(false)
  }

  const openFinalizeInviteModal = () => {
    setShowFinalizeModal(true)
  }
  const closeFinalizeInviteModal = () => {
    setShowFinalizeModal(false)
  }

  const handleShowFinalizeModal = (e, user) => {
    let users = []
    if (user) {
      users.push(user)
    } else {
      users = data?.Interests?.Workplace_member_shared_interest?.map((x) => x.user_info)
    }

    setSelectedMembers(users)

    if (users?.length > 0) {
      openFinalizeInviteModal()
    }
  }
  const removeMember = (id) => {
    setSelectedMembers(selectedMembers?.filter((u) => u.id !== id))
  }

  return (
    <div className={`${parentStyles.card} `}>
      <CardTitle
        title={
          data?.group_info?.group_type === 'expertise'
            ? t('formlabel.expertise_plural')
            : t('formlabel.interest_plural')
        }
      />
      <div className={styles.interestContainer}>
        <div className={styles.userData}>
          <CardSubTitle
            titleStyle={styles.subTitle}
            title={
              data?.group_info?.group_type === 'expertise'
                ? t(`dashboard.expertises.empty.titleBoxCount`, {
                    count: data?.Interests?.Workplace_member_shared_interest?.length || 0
                  })
                : t(`dashboard.interests.empty.titleBoxCount`, {
                    count: data?.Interests?.Workplace_member_shared_interest?.length || 0
                  })
            }
          />

          {data?.Interests?.Workplace_member_shared_interest?.length > 0 ? (
            <React.Fragment>
              <UserList
                users={data.Interests.Workplace_member_shared_interest}
                loggedInUser={loggedInUser}
                renderAction={(userInfo) => (
                  <Button
                    style='transparent'
                    text={t('global.invite')}
                    handleClick={(e) => handleShowFinalizeModal(e, userInfo)}
                  />
                )}
              />
              {data?.Interests?.Workplace_member_shared_interest.length > 0 && (
                <Button
                  handleClick={handleShowFinalizeModal}
                  customStyle={styles.inviteButton}
                  style='orange'
                  text={
                    data.Interests.Workplace_member_shared_interest.length > 1
                      ? t('dashboard.interests.empty.btnSendInvite_plural')
                      : t('dashboard.interests.empty.btnSendInvite')
                  }
                />
              )}
            </React.Fragment>
          ) : (
            <React.Fragment>
              {data?.group_info?.group_type === 'expertise' ? (
                <EmptyCard
                  className={styles.invites}
                  contentTitle={t('dashboard.expertises.empty.title')}
                  contentText={t('dashboard.expertises.empty.text')}
                  contentImage='pending-invites'
                  contentButton={t('dashboard.expertises.empty.btn')}
                  contentButtonAction={openInterestModal}
                />
              ) : (
                <EmptyCard
                  className={styles.invites}
                  contentTitle={t('dashboard.interests.empty.title')}
                  contentText={t('dashboard.interests.empty.text')}
                  contentImage='pending-invites'
                  contentButton={t('dashboard.interests.empty.btn')}
                  contentButtonAction={openInterestModal}
                />
              )}
            </React.Fragment>
          )}
        </div>

        <div className={styles.interestWPCount}>
          <ActivityBoxInterests
            activityCount={data?.Interests?.Rate_of_workplace_members_shared_interest?.value}
            activityText={
              data?.group_info?.group_type === 'expertise'
                ? t('dashboard.expertises.wpMemberInterests')
                : t('dashboard.interests.wpMemberInterests')
            }
            handleInvites={handleShowFinalizeModal}
          />
          <ActivityBoxInterests
            activityCount={data?.Interests?.Count_of_new_workplace_members_shared_interest?.value}
            activityText={
              data?.group_info?.group_type === 'expertise'
                ? t('dashboard.expertises.newWpMemberInterests')
                : t('dashboard.interests.newWpMemberInterests')
            }
            handleInvites={handleShowFinalizeModal}
          />
        </div>
      </div>

      {showFinalizeModal && (
        <Modal
          isOpen={showFinalizeModal}
          title={t('popinFinalizeInvitations.title')}
          handleClose={closeFinalizeInviteModal}>
          <FinalizeInvitationsModal
            members={selectedMembers}
            sendInvites={handleSendInvites}
            id={data?.group_id}
            type='list'
            callback={() => {
              setShowFinalizeModal(false)
              setShowSuccessModal(true)
            }}
            removeMember={removeMember}
            closeModal={closeFinalizeInviteModal}
          />
        </Modal>
      )}
      {showSuccessModal && (
        <Modal isOpen={showSuccessModal} handleClose={() => setShowSuccessModal(false)}>
          <InviteMembersSuccessModal closeModal={() => setShowSuccessModal(false)} />
        </Modal>
      )}
      {isInterestModalOpen && (
        <Modal
          isOpen={isInterestModalOpen}
          title={
            data?.group_info?.group_type === 'expertise'
              ? t('group.editGroup.groupInterests', { type: t('formlabel.expertise', { count: 0 }).toLowerCase() })
              : t('group.editGroup.groupInterests', { type: t('formlabel.interest', { count: 0 }).toLowerCase() })
          }
          handleClose={closeInterestModal}>
          <AddGroupInterests
            isModal={true}
            groupType={data?.group_info?.group_type}
            groupId={data?.group_id}
            groupName={data?.group_name}
            closeModal={closeInterestModal}
            interests={
              data?.group_info?.group_type === 'expertise' ? data?.group_info?.expertises : data?.group_info?.interests
            }
          />
        </Modal>
      )}
    </div>
  )
}

export default Interests
